import { LineSectionInterface, TripInterface } from '../trips/types';
import { CarInterface } from '../fleet/types';
import { EmployeeInterface } from '../employees/types';

/*
 * Action Types
 */
export enum SchedulesMatrixTypes {
  LIST_SCHEDULES_MATRIX_REQUEST = '@schedulesMatrix/LIST_SCHEDULES_MATRIX_REQUEST',
  LIST_SCHEDULES_MATRIX_SUCCESS = '@schedulesMatrix/LIST_SCHEDULES_MATRIX_SUCCESS',
  LIST_SCHEDULES_MATRIX_FAILURE = '@schedulesMatrix/LIST_SCHEDULES_MATRIX_FAILURE',

  GET_SCHEDULES_MATRIX_REQUEST = '@schedulesMatrix/GET_SCHEDULES_MATRIX_REQUEST',
  GET_SCHEDULES_MATRIX_SUCCESS = '@schedulesMatrix/GET_SCHEDULES_MATRIX_SUCCESS',
  GET_SCHEDULES_MATRIX_FAILURE = '@schedulesMatrix/GET_SCHEDULES_MATRIX_FAILURE',

  CREATE_SCHEDULES_MATRIX_REQUEST = '@schedulesMatrix/CREATE_SCHEDULES_MATRIX_REQUEST',
  CREATE_SCHEDULES_MATRIX_SUCCESS = '@schedulesMatrix/CREATE_SCHEDULES_MATRIX_SUCCESS',
  CREATE_SCHEDULES_MATRIX_FAILURE = '@schedulesMatrix/CREATE_SCHEDULES_MATRIX_FAILURE',

  UPDATE_SCHEDULES_MATRIX_REQUEST = '@schedulesMatrix/UPDATE_SCHEDULES_MATRIX_REQUEST',
  UPDATE_SCHEDULES_MATRIX_SUCCESS = '@schedulesMatrix/UPDATE_SCHEDULES_MATRIX_SUCCESS',
  UPDATE_SCHEDULES_MATRIX_FAILURE = '@schedulesMatrix/UPDATE_SCHEDULES_MATRIX_FAILURE',

  DELETE_SCHEDULES_MATRIX_REQUEST = '@schedulesMatrix/DELETE_SCHEDULES_MATRIX_REQUEST',
  DELETE_SCHEDULES_MATRIX_SUCCESS = '@schedulesMatrix/DELETE_SCHEDULES_MATRIX_SUCCESS',
  DELETE_SCHEDULES_MATRIX_FAILURE = '@schedulesMatrix/DELETE_SCHEDULES_MATRIX_FAILURE',

  LIST_SCHEDULES_MATRIX_CONFIG_REQUEST = '@schedulesMatrix/LIST_SCHEDULES_MATRIX_CONFIG_REQUEST',
  LIST_SCHEDULES_MATRIX_CONFIG_SUCCESS = '@schedulesMatrix/LIST_SCHEDULES_MATRIX_CONFIG_SUCCESS',
  LIST_SCHEDULES_MATRIX_CONFIG_FAILURE = '@schedulesMatrix/LIST_SCHEDULES_MATRIX_CONFIG_FAILURE',

  GET_SCHEDULES_MATRIX_CONFIG_REQUEST = '@schedulesMatrix/GET_SCHEDULES_MATRIX_CONFIG_REQUEST',
  GET_SCHEDULES_MATRIX_CONFIG_SUCCESS = '@schedulesMatrix/GET_SCHEDULES_MATRIX_CONFIG_SUCCESS',
  GET_SCHEDULES_MATRIX_CONFIG_FAILURE = '@schedulesMatrix/GET_SCHEDULES_MATRIX_CONFIG_FAILURE',

  CREATE_SCHEDULES_MATRIX_CONFIG_REQUEST = '@schedulesMatrix/CREATE_SCHEDULES_MATRIX_CONFIG_REQUEST',
  CREATE_SCHEDULES_MATRIX_CONFIG_SUCCESS = '@schedulesMatrix/CREATE_SCHEDULES_MATRIX_CONFIG_SUCCESS',
  CREATE_SCHEDULES_MATRIX_CONFIG_FAILURE = '@schedulesMatrix/CREATE_SCHEDULES_MATRIX_CONFIG_FAILURE',

  UPDATE_SCHEDULES_MATRIX_CONFIG_REQUEST = '@schedulesMatrix/UPDATE_SCHEDULES_MATRIX_CONFIG_REQUEST',
  UPDATE_SCHEDULES_MATRIX_CONFIG_SUCCESS = '@schedulesMatrix/UPDATE_SCHEDULES_MATRIX_CONFIG_SUCCESS',
  UPDATE_SCHEDULES_MATRIX_CONFIG_FAILURE = '@schedulesMatrix/UPDATE_SCHEDULES_MATRIX_CONFIG_FAILURE',

  DELETE_SCHEDULES_MATRIX_CONFIG_REQUEST = '@schedulesMatrix/DELETE_SCHEDULES_MATRIX_CONFIG_REQUEST',
  DELETE_SCHEDULES_MATRIX_CONFIG_SUCCESS = '@schedulesMatrix/DELETE_SCHEDULES_MATRIX_CONFIG_SUCCESS',
  DELETE_SCHEDULES_MATRIX_CONFIG_FAILURE = '@schedulesMatrix/DELETE_SCHEDULES_MATRIX_CONFIG_FAILURE',

  LIST_TRIP_SCHEDULES_REQUEST = '@schedulesMatrix/LIST_TRIP_SCHEDULES_REQUEST',
  LIST_TRIP_SCHEDULES_SUCCESS = '@schedulesMatrix/LIST_TRIP_SCHEDULES_SUCCESS',
  LIST_TRIP_SCHEDULES_FAILURE = '@schedulesMatrix/LIST_TRIP_SCHEDULES_FAILURE',

  GET_TRIP_SCHEDULES_REQUEST = '@schedulesMatrix/GET_TRIP_SCHEDULES_REQUEST',
  GET_TRIP_SCHEDULES_SUCCESS = '@schedulesMatrix/GET_TRIP_SCHEDULES_SUCCESS',
  GET_TRIP_SCHEDULES_FAILURE = '@schedulesMatrix/GET_TRIP_SCHEDULES_FAILURE',

  CREATE_TRIP_SCHEDULES_REQUEST = '@schedulesMatrix/CREATE_TRIP_SCHEDULES_REQUEST',
  CREATE_TRIP_SCHEDULES_SUCCESS = '@schedulesMatrix/CREATE_TRIP_SCHEDULES_SUCCESS',
  CREATE_TRIP_SCHEDULES_FAILURE = '@schedulesMatrix/CREATE_TRIP_SCHEDULES_FAILURE',

  UPDATE_TRIP_SCHEDULES_REQUEST = '@schedulesMatrix/UPDATE_TRIP_SCHEDULES_REQUEST',
  UPDATE_TRIP_SCHEDULES_SUCCESS = '@schedulesMatrix/UPDATE_TRIP_SCHEDULES_SUCCESS',
  UPDATE_TRIP_SCHEDULES_FAILURE = '@schedulesMatrix/UPDATE_TRIP_SCHEDULES_FAILURE',

  DELETE_TRIP_SCHEDULES_REQUEST = '@schedulesMatrix/DELETE_TRIP_SCHEDULES_REQUEST',
  DELETE_TRIP_SCHEDULES_SUCCESS = '@schedulesMatrix/DELETE_TRIP_SCHEDULES_SUCCESS',
  DELETE_TRIP_SCHEDULES_FAILURE = '@schedulesMatrix/DELETE_TRIP_SCHEDULES_FAILURE',

  TRIP_SCHEDULES_INFO_REQUEST = '@schedulesMatrix/TRIP_SCHEDULES_INFO_REQUEST',
  TRIP_SCHEDULES_INFO_SUCCESS = '@schedulesMatrix/TRIP_SCHEDULES_INFO_SUCCESS',
  TRIP_SCHEDULES_INFO_FAILURE = '@schedulesMatrix/TRIP_SCHEDULES_INFO_FAILURE',

  TRIP_SCHEDULES_PROFILE_RESEVATIONS_REQUEST = '@schedulesMatrix/TRIP_SCHEDULES_PROFILE_RESEVATIONS_REQUEST',
  TRIP_SCHEDULES_PROFILE_RESEVATIONS_SUCCESS = '@schedulesMatrix/TRIP_SCHEDULES_PROFILE_RESEVATIONS_SUCCESS',
  TRIP_SCHEDULES_PROFILE_RESEVATIONS_FAILURE = '@schedulesMatrix/TRIP_SCHEDULES_PROFILE_RESEVATIONS_FAILURE',
}

/*
 * Data types
 */

export interface SchedulesMatrixConfigInterface {
  id: string;
  type: number;
  open: boolean | null;
  service: string;
  start: string;
  end: string;
  createdAt: Date;
  updatedAt: Date;
  startItineraryLineStopId: null;
  endItineraryLineStopId: null;
  scheduleMatrixId: string;
  employeeId: string;
  carId: string;
  lineSectionId: string;
  LineSection: LineSectionInterface;
  Car: CarInterface;
  TransportEmployee: EmployeeInterface;
  ScheduleMatrix: { status: boolean };
}

export interface SchedulesMatrixInterface {
  id: string;
  weekdays: string[];
  color: string;
  name: string;
  type?: number | null;
  status: boolean;
  createdAt: Date;
  updatedAt: Date;
  transportOperatorId: string;
  ScheduleMatrixConfigs: SchedulesMatrixConfigInterface[];
}

export interface TripScheduleInfoInterface {
  id: string;
  hourType: number;
  place: string;
  unboardingStartTime: string;
  unboardingEndTime: string;
  boardingStartTime: string;
  boardingEndTime: string;
  departureTime: string;
  arrivalTime: string;
  comment: string;
  createdAt: string;
  updatedAt: string;
  tripScheduleId: string;
}
export interface TripScheduleInterface {
  id: string;
  date: Date;
  footCapacity: null;
  sitCapacity: null;
  vehicleCapacity: null;
  createdAt: Date;
  updatedAt: Date;
  deleted: boolean;
  employeeId: string;
  carId: string;
  start: string;
  end: string;
  scheduleMatrixConfigId: string;
  ScheduleMatrixConfig: SchedulesMatrixConfigInterface;
  TripScheduleInfo?: TripScheduleInfoInterface;
  Trip?: TripInterface;
  TripScheduleProfileReservations?: {
    id: string;
    quantity: number;
    createdAt: string;
    updatedAt: string;
    tripScheduleId: string;
    profileId: string;
  }[];
}

/*
 * State type
 */
export interface SchedulesMatrixState {
  readonly schedulesMatrixList: SchedulesMatrixInterface[];
  readonly schedulesMatrixData: SchedulesMatrixInterface | null;
  readonly schedulesMatrixConfigList: SchedulesMatrixConfigInterface[];
  readonly schedulesMatrixConfigData: SchedulesMatrixConfigInterface[] | null;
  readonly tripSchedulesList: TripScheduleInterface[];
  readonly tripSchedulesData: TripScheduleInterface | null;
  readonly totalCount: number;
  readonly loading: boolean;
  readonly error: boolean;
  readonly created: boolean;
}
